
import { computed, defineComponent } from 'vue';
import { Colour, getForegroundColourFromBackground } from '../../../helpers/colour';
import TpxFormNavigation from './form-navigation.vue';
import './form.scss';

/**
  * Form
  * 
  * @example
  * <code>import TpxForm from '@manifesto-tech/tpximpact-design-system/components/molecules/form/form.vue'</code>
  */
export default defineComponent({
  name: 'TpxForm',

  components: {
    TpxFormNavigation,
  },

  props: {
    /**
     * Background colour of the form
     */
    backgroundColour: {
      type: String,
      validator: (value) => {
        return Object.values(Colour).includes(value as Colour);
      },
    },

    /**
     * Destination for the form post
     */
    href: {
      type: String,
    },

    /**
     * Include default navigation bar as part of form?
     */
    includeNavigation: {
      default: true,
      type: Boolean,
    },

    /**
     * Is the form disabled?
     */
    isDisabled: {
      type: Boolean,
    },

    /**
     * Method
     * get or set
     */
    method: {
      default: 'set',
      type: String,
      validator: (value: string) => {
        return ['get', 'set'].includes(value);
      },
    },
  },

  data() {
    return {
      colourClasses: computed(() => ({
        [`bg--${this.backgroundColour}`]: !!this.backgroundColour,
        [`text--${getForegroundColourFromBackground(this.backgroundColour)}`]: !!this.backgroundColour,
        [`padding`]: !!this.backgroundColour,
      })),
      url: window.location.href
    }
  },
});
